module.exports = __webpack_public_path__ + "static/media/joyable9.a05a56f6.jpg";